import produce from 'immer';
import {
  GET_LLM_CONFIG,
  ADD_LLM_CONFIG,
  UPDATE_LLM_CONFIG,
  DELETE_LLM_CONFIG,
  CLEAR_LLM_CONFIG,
  GET_LLM_CONFIG_VERSIONS
} from 'src/actions/llmCompletionConfig';

const initialState = {
  byBotId: {},
  versionsByBotId: {}
};

const llmCompletionConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LLM_CONFIG: {
      const { config, botId } = action.payload || {};
      const resolvedBotId = botId || (config ? config.bot_id : null);
      return produce(state, draft => {
        if (resolvedBotId) {
          draft.byBotId[resolvedBotId] = config;
        }
      });
    }

    case ADD_LLM_CONFIG: {
      const { config } = action.payload;
      return produce(state, draft => {
        if (config && config.bot_id) {
          draft.byBotId[config.bot_id] = config;
        }
      });
    }

    case UPDATE_LLM_CONFIG: {
      const { config } = action.payload;
      return produce(state, draft => {
        if (config && config.bot_id) {
          draft.byBotId[config.bot_id] = config;
        }
      });
    }

    case DELETE_LLM_CONFIG: {
      const { id } = action.payload || {};
      return produce(state, draft => {
        if (!id) {
          return;
        }
        Object.keys(draft.byBotId).forEach(botId => {
          if (draft.byBotId[botId]?.id === id) {
            draft.byBotId[botId] = null;
          }
        });
      });
    }

    case CLEAR_LLM_CONFIG: {
      const { botId } = action.payload || {};
      return produce(state, draft => {
        if (botId) {
          draft.byBotId[botId] = null;
          draft.versionsByBotId[botId] = [];
        } else {
          draft.byBotId = {};
          draft.versionsByBotId = {};
        }
      });
    }

    case GET_LLM_CONFIG_VERSIONS: {
      const { botId, versions } = action.payload || {};
      return produce(state, draft => {
        if (botId) {
          draft.versionsByBotId[botId] = versions || [];
        }
      });
    }

    default: {
      return state;
    }
  }
};

export default llmCompletionConfigReducer; 
